import { Link } from "react-router-dom";

const Hero = () => {
    return (
        <section
            id="hero"
            className="relative min-h-screen overflow-hidden px-6 pt-20 md:px-12 lg:px-20"
        >
            <div className="mx-auto grid min-h-[85vh] max-w-[1600px] items-center gap-16 lg:grid-cols-2">

                <div className="relative z-10">

                    <h1 className="text-6xl font-black leading-[0.85] tracking-tighter text-gray-900 sm:text-7xl md:text-8xl lg:text-[110px]">
                        New
                        <br />
                        Collection
                        <br />
                        <span className="text-indigo-600">
                            Arrived.
                        </span>
                    </h1>

                    <p className="mt-10 max-w-md text-lg leading-relaxed text-gray-500 md:text-xl">
                        Discover carefully selected products designed
                        to make everyday life simpler, smarter and better.
                    </p>

                    <div className="mt-10">
                        <Link
                            to="/products"
                            className="group inline-flex items-center gap-4 rounded-full bg-gray-900 px-7 py-4 text-lg font-semibold text-white transition-all duration-300 hover:bg-indigo-600 hover:shadow-xl"
                        >
                            Explore Collection

                            <span className="transition-transform duration-300 group-hover:translate-x-2">
                                →
                            </span>
                        </Link>
                    </div>

                </div>


                <div className="relative flex min-h-[600px] items-center justify-center">

                    <div className="absolute h-[400px] w-[400px] rounded-full bg-indigo-100 md:h-[550px] md:w-[550px]" />

                    <div className="absolute right-0 top-10 hidden text-[120px] font-black leading-none tracking-tighter text-black/5 md:block">
                        NEW
                    </div>


                    <div
                        className="
                            absolute
                            left-[5%]
                            top-[15%]
                            z-10
                            h-[350px]
                            w-[240px]
                            rotate-[-8deg]
                            overflow-hidden
                            rounded-[2rem]
                            bg-white
                            p-5
                            shadow-2xl
                            transition-all
                            duration-500
                            hover:z-30
                            hover:rotate-0
                            hover:scale-105
                        "
                    >
                        <img
                            src="https://cdn.dummyjson.com/product-images/beauty/essence-mascara-lash-princess/thumbnail.webp"
                            alt="Featured product"
                            className="h-full w-full object-contain"
                        />

                        <div className="absolute bottom-5 left-5 rounded-full bg-white/90 px-4 py-2 text-xs font-semibold shadow">
                            Beauty
                        </div>
                    </div>


                    <div
                        className="
                            absolute
                            right-[5%]
                            top-[30%]
                            z-20
                            h-[400px]
                            w-[270px]
                            rotate-[7deg]
                            overflow-hidden
                            rounded-[2rem]
                            bg-white
                            p-5
                            shadow-2xl
                            transition-all
                            duration-500
                            hover:rotate-0
                            hover:scale-105
                        "
                    >
                        <img
                            src="https://cdn.dummyjson.com/product-images/beauty/eyeshadow-palette-with-mirror/thumbnail.webp"
                            alt="Featured product"
                            className="h-full w-full object-contain"
                        />

                        <div className="absolute bottom-5 left-5 rounded-full bg-gray-900 px-4 py-2 text-xs font-semibold text-white shadow">
                            Featured
                        </div>
                    </div>


                    <div className="absolute bottom-8 left-1/2 z-30 -translate-x-1/2 rounded-2xl bg-white px-6 py-4 shadow-xl">
                        <p className="text-xs uppercase tracking-widest text-gray-400">
                            Trending
                        </p>

                        <p className="mt-1 font-bold text-gray-900">
                            Shop the latest
                        </p>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Hero;